import R from 'ramda'

const COMMENTS_ON_DISPLAY_TYPE = 'Comments On Post'

const INITIAL_POST_TRIGGER_TYPE = 'IG_INITIAL_POST'
const COMMENTS_ON_TRIGGER_TYPE = 'COMMENTS_ON'

const isCommentsOnFormTrigger = R.propEq('type', COMMENTS_ON_DISPLAY_TYPE)

const constructExistingPostTrigger = R.applySpec({
  type: R.always(COMMENTS_ON_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T
})

const constructNewImagePostTrigger = R.applySpec({
  type: R.always(INITIAL_POST_TRIGGER_TYPE),
  result: R.always(COMMENTS_ON_TRIGGER_TYPE),
  primary: R.always(true),
  operator: R.always('AND'),
  data: {
    type: R.always('image'),
    endpoint: R.always('media'),
    searchParams: {
      caption: R.prop('postText'),
      image_url: R.prop('imageUrl'),
      media_type: R.ifElse(
        R.prop('isStory'),
        R.always('STORIES'),
        R.always(undefined)
      )
    }
  }
})

const constructNewVideoPostTrigger = R.applySpec({
  type: R.always(INITIAL_POST_TRIGGER_TYPE),
  result: R.always(COMMENTS_ON_TRIGGER_TYPE),
  primary: R.always(true),
  operator: R.always('AND'),
  data: {
    type: R.always('video'),
    endpoint: R.always('media'),
    searchParams: {
      caption: R.prop('postText'),
      video_url: R.prop('videoUrl'),
      media_type: R.ifElse(
        R.prop('isStory'),
        R.always('STORIES'),
        R.always('REELS')
      )
    }
  }
})

const convertCommentsOnFormTriggerToWidgetTrigger = R.cond([
  [R.propEq('action', 'EXISTING_POST'), constructExistingPostTrigger],
  [R.propEq('action', 'NEW_POST_IMAGE'), constructNewImagePostTrigger],
  [R.propEq('action', 'NEW_POST_VIDEO'), constructNewVideoPostTrigger]
])

export { isCommentsOnFormTrigger, convertCommentsOnFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/instagram/form-to-widget/comments-on-post.js